import { useEffect, useState } from "react";
import { env } from "../../../env/env";
import "../PrintCheckoutPage";
import DesignApi from "../../../api/DesignApi";
import { getSizeLabel, getSizeDimensions, getTemplateThumb } from "../../../util/utils";
import { Skeleton } from "antd";

export function MatchingDesigns({ order }: any) {
  const [loading, setLoading] = useState(false);
  const [noMatchingDesigns, setNoMatchingDesigns] = useState(false);
  const [templates, setTemplates] = useState([] as any);

  useEffect(() => {
    setLoading(true);

    const lastAddedDesignId = order.items[0].designId;

    DesignApi.getDesign(lastAddedDesignId).then(resp => {
      resp.json().then(data => {
        const design = data;
        const templateId = design.templateId;

        if (templateId) {
          DesignApi.getTemplateSets(templateId).then(resp2 => {
            resp2.json().then(data2 => {
              setLoading(false);

              if (data2.length > 1) {
                setTemplates(data2);
              } else {
                setNoMatchingDesigns(true)
              }
            });
          })
        } else {
          setLoading(false);
          setNoMatchingDesigns(true)
        }
      });
    })
  }, [order.items]);

  return (
    <>
      {!noMatchingDesigns &&
        <div className={`matching-designs`}>
          <h3>Create a matching design for your menu</h3>

          <div className="container">
            {loading && <Skeleton active />}
            {!loading &&
              <div className="templates-carousel">
                {templates.map((template: any) =>
                  <div>
                    <a href={`${env.timberContextPath}/design?parentId=${template.id}`}>
                      <img src={getTemplateThumb(template.id, template.memberId)} alt={template.title} />
                      <label>
                        <b>{getSizeLabel(template.size)}</b><br />
                        {getSizeDimensions(template.size)}
                      </label>
                    </a>
                  </div>
                )}
              </div>
            }
          </div>
        </div>
      }
    </>
  );
}
